var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-box"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":""}}),_c('h2',[_vm._v("欢迎使用供应链协同平台系统")])])
}]

export { render, staticRenderFns }